



























































import { defineComponent, computed, ref } from "@vue/composition-api";
import { useVuex } from "@/hooks/use-vuex";
import { useRouter, useMeta } from "@/hooks/use-router";

export default defineComponent({
  setup(_, ctx) {
    const titlePortal = ref(null);
    const {
      store: { state, commit, getters, dispatch }
    } = useVuex();
    const router = useRouter();
    const meta = useMeta(ctx);
    const route = computed(() => ctx.root.$route);
    const themeColor = computed(() => getters.Wallet.wallet?.color);
    const openDrawer = () => commit.NavBar.setDrawer({ value: true });
    const toggleHelp = dispatch.Help.toggle;
    const helpOpen = computed(() => state.Help.open);
    const notificationCount = computed(
      () => getters.Notifications.notificationCount
    );
    const loading = computed(() => state.Loading.loading);

    const hasTitlePassengers = computed(
      () => (titlePortal?.value as any)?.transports["page-title"]?.length > 0
    );

    const back = () =>
      meta?.value?.backRoute
        ? router.push(meta?.value?.backRoute || "")
        : router.go(-1);

    return {
      meta,
      openDrawer,
      notificationCount,
      toggleHelp,
      back,
      helpOpen,
      route,
      loading,
      titlePortal,
      hasTitlePassengers,
      themeColor
    };
  }
});
